<template>
  <div class="forchange-textarea">
    <div class="content" v-text="inputValue"></div>
    <textarea
      ref="input"
      v-model="inputValue"
      class="input-field"
      v-bind="$props"
      :type="type"
      @keyup="handleKeyUp"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="changeHander"
    ></textarea>
  </div>
</template>

<script>
const COMPONENT_NAME = 'enroll-input';
const EVENT_INPUT = 'input';
const EVENT_BLUR = 'blur';
const EVENT_FOCUS = 'focus';
const EVENT_CHANGE = 'change';
const EVENT_KEYUP = 'keyup';
const EVENT_INPUT_CHANGE = 'inputChange';

export default {
  name: COMPONENT_NAME,

  props: {
    value: [String, Number],

    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      isFocus: false,
      isOnComposition: false,
      emittedInput: false,
    };
  },

  watch: {
    value(newValue) {
      this.inputValue = newValue;
    },

    inputValue(newValue) {
      this.$emit(EVENT_INPUT, newValue.trim());
    },
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    handleInputChange(e) {
      this.$emit(EVENT_INPUT_CHANGE, e);
    },

    handleKeyUp(e) {
      this.$emit(EVENT_KEYUP, e);
    },

    changeHander(e) {
      this.$emit(EVENT_CHANGE, e);
    },

    handleFocus(e) {
      this.$emit(EVENT_FOCUS, e);
    },

    handleBlur(e) {
      this.$emit(EVENT_BLUR, e);
    },
  },
};
</script>

<style lang="scss" scoped>
.forchange-textarea {
  position: relative;
  width: 100%;
  min-height: 34px;
}
input:disabled,
textarea:disabled {
  color: #383333;
  -webkit-opacity: 1;
  -webkit-text-fill-color: #383333;
}

textarea {
  width: 100%;
  height: 100%;
  min-height: 24px;
  padding: 0;
  text-align: right;
  border: none;
  resize: none;
  &::placeholder {
    color: #383333;
  }
}

.input-field {
  position: absolute;
  top: 0px;
  left: 0;
}

.content {
  width: 100%;
  min-height: 44px;
  white-space: wrap;
  word-break: break-all;
  visibility: hidden;
}
</style>
